import { HistoricoTranche, TIPO_CALCULO_LIMITE } from './../../../model/tranche.model';
import { Tranche } from 'src/app/model/tranche.model';
import { TrancheService } from 'src/app/shared/services/tranche.service';
import { Component, EventEmitter, Injector, Input, OnInit, Output } from "@angular/core";


@Component({
    selector: 'app-tranche-historico',
    templateUrl: './tranche-historico.component.html',
    standalone: false
})

export class TrancheHistoricoComponent implements OnInit{

  @Input() public tranches: Tranche;
  @Input() public historico: HistoricoTranche;
  @Output() public fechaHistorico = new EventEmitter()
  private opcoesEdicaoTipoCalculoLimite = TIPO_CALCULO_LIMITE;

  constructor(private trancheService: TrancheService,
    protected injector: Injector,) {
  }

  ngOnInit(): void {

  }



  fecharHistorico() {
    this.fechaHistorico.emit()
  }





}
